import { useQuery } from "@tanstack/react-query";
import { getTrainingSessionsByEmployeeId } from "../api/requests";

export const useEmployeeTrainingSessions = (
    key: string,
    employeeId: string | null,
    challengeId?: string,
    sessionId?: string,
) => {
    const { data, isFetching } = useQuery({
        queryKey: [`training-sessions-${key}`, employeeId, challengeId, sessionId],
        queryFn: () => getTrainingSessionsByEmployeeId(employeeId, challengeId, sessionId),
        refetchOnWindowFocus: false,
    });

    return { data: data?.items, isFetching };
};
